<template>
  <div>
    <!-- user access is disabled -->
    <div v-if="!config.IS_USER_ACTIVE">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert class="info text-xs-center" value="true">
              Access is currently denied for your account
              <br /><br />
              Please contact your community admin if you did not expect to see this message.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- one or more of user's joining request not approved yet -->
    <div v-else-if="config.IS_USER_ACTIVE && config.ALL_UNITS.findIndex(rec => rec.rel_status !== 'Linked') >= 0">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <span v-for="(unit, i) in config.ALL_UNITS.filter(rec => rec.rel_status !== 'Linked')" :key="i" color="info" class="text-xs-center" value="true">
              <v-alert v-if="unit.rel_status === 'Pending Approval'">
                Your joining request for <span class="subheading yellow--text">{{(unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + config.COMM_NAME}}</span> is yet to be approved by your community admin.
                <br /><br />
                It may take few hours to process your request and you will be notified as soon as it is done.
                <div>
                  <v-btn class="mb-0" flat color="accent" @click="logout">Logout</v-btn>
                </div>
              </v-alert>
              <v-alert v-else-if="unit.rel_status === 'Rejected'">
                Your joining request for <span class="yellow--text">{{unit.block_nm + ' ' + unit.unit_no}}</span> was rejected with below reason.
                <div class="text-xs-center white--text mt-2">
                  "{{ unit.rej_reason }}"
                </div>
                <div>
                  <v-btn flat class="mb-0" color="accent" @click="cancelReq(unit)">Cancel & Sign-up again</v-btn>
                </div>
              </v-alert>
              <v-alert v-else-if="unit.rel_status === 'Delinked' && config.ALL_UNITS.length === 1">
                You are currently delinked from <span class="yellow--text">{{(unit.block_nm ? (unit.block_nm + ' ' + unit.unit_no + ' in ') : '') + config.COMM_NAME}}</span>
                <br /><br />
                Please contact your community admin if you did not expect to see this message.
                <div>
                  <v-btn class="mb-0" flat color="accent" @click="logout">Logout</v-btn>
                </div>
              </v-alert>
            </span>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- user has access to atleast one unit -->
    <div v-if="config.IS_USER_ACTIVE && config.UNITS.findIndex(rec => rec.rel_status === 'Linked') >= 0">
      <v-container class="pa-2" grid-list-md>
        <v-layout row wrap>

          <!-- Joining requests -->
          <v-flex xs12 v-if="joinReq.length" class="pb-2">
            <v-card :to="{path: (config.IS_ADMIN ? '/users' : '/profile/join')}">
              <v-card-title class="pa-2 subheading primary lighten-2 white--text">
                Joining Requests
              </v-card-title>
              <v-card-text class="pa-2">
                <span class="ml-2">{{ joinReq.length + ' request' + (joinReq.length > 1 ?'s' : '') }} pending for your review!</span>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- onboarding pending -->
      <v-flex xs12 v-if="isCommSetupPend">
        <v-card class="mb-1">
          <v-card-title class="pa-2 subheading primary lighten-2 white--text">
            What's next?
          </v-card-title>
          <v-img
          :src="config.STATIC_FILES_DIR + '/img/others/guard_setup.png'"
          :aspect-ratio="5"
          ></v-img>
          <v-card-text>
            <div class="subheading pb-2">
              <strong>
                <span v-if="commSetupScore.setup_score.corScore <= commSetupScore.setup_score.corScoreBase">Almost everything is setup for your community. You are just few steps away!</span>
                <span v-else>I guess you are not making use of all Smartility features. Complete remaining setup and enjoy them all!</span>
              </strong>
            </div>
            <ul>
              <li v-if="commSetupScore.setup_score.corScore <= commSetupScore.setup_score.corScoreBase">
                Onboard your residents by <a href="#" @click="dlgHowToResDir=true">uploading resident directory</a>
              </li>
              <li v-if="commSetupScore.setup_score.vmScore <= commSetupScore.setup_score.vmScoreBase">
                Download and install app in your <a href="#" @click="dlgHowToSecGaurd=true">security guard device for managing visitors</a>
              </li>
            </ul>
          </v-card-text>
          <v-card-text class="text-xs-center pt-1 grey lighten-4">
            <div class="title">
              Setup Completion: <span class="display-1">{{commSetupScore.setup_score.avgScore}}%</span>
              <v-btn icon @click="dlgCommSetup=true"><v-icon>open_in_new</v-icon></v-btn>
            </div>
            <v-layout row wrap>
              <v-flex xs3>
                <div class="accent--text">
                  Core <span v-if="$vuetify.breakpoint.smAndUp">Module</span>
                </div>
                <v-progress-linear :value="commSetupScore.setup_score.corScore" height="20" color="accent">{{commSetupScore.setup_score.corScore}}%</v-progress-linear>
              </v-flex>
              <v-flex xs3>
                <div class="accent--text">
                  Visitor <span v-if="$vuetify.breakpoint.smAndUp">Module</span>
                </div>
                <v-progress-linear :value="commSetupScore.subscription.visitor_module ? commSetupScore.setup_score.vmScore : 0" height="20" color="accent">{{commSetupScore.subscription.visitor_module ? commSetupScore.setup_score.vmScore + '%' : 'Disabled'}}</v-progress-linear>
              </v-flex>
              <v-flex xs3>
                <div class="accent--text">
                  Accounting <span v-if="$vuetify.breakpoint.smAndUp">Module</span>
                </div>
                <v-progress-linear :value="commSetupScore.subscription.accounts_module ? commSetupScore.setup_score.acScore : 0" height="20" color="accent">{{commSetupScore.subscription.accounts_module ? commSetupScore.setup_score.acScore + '%' : 'Disabled'}}</v-progress-linear>
              </v-flex>
              <v-flex xs3>
                <div class="accent--text">
                  Facility <span v-if="$vuetify.breakpoint.smAndUp">Module</span>
                </div>
                <v-progress-linear :value="commSetupScore.subscription.facility_module ? commSetupScore.setup_score.fmScore : 0" height="20" color="accent">{{commSetupScore.subscription.facility_module ? commSetupScore.setup_score.fmScore + '%' : 'Disabled'}}</v-progress-linear>
              </v-flex>
            </v-layout>

          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-if="!isMobAdminUser">
        <v-card class="mb-1">
          <v-card-title class="pa-2 subheading primary lighten-2 white--text">
            Welcome to Smartility Admin!
          </v-card-title>
          <v-card-text class="pb-1">
            Do you know, you can access this admin app in your mobile phone as well?
            <v-layout row wrap class="mt-2">
              <v-flex xs6 sm3 class="text-xs-center">
                Android
                <div>
                  <a target="_blank" href='https://play.google.com/store/apps/details?id=in.smartility.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img width="150" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
                </div>
              </v-flex>
              <v-flex xs6 sm3 class="text-xs-center">
                iPhone
                <div class="pa-2">
                  <a @click="dlgHowToiPhone=true"><img alt='Install web app' width="140" :src="config.STATIC_FILES_DIR + '/img/others/pwa_app.png'"/></a>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- complaints -->
      <v-flex xs6 sm3 v-if="!config.IS_OTHER_USER">
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/complaints'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">headset_mic</v-icon>Complaints
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{ totMine }}
            <v-btn fab small class="primary lighten-2" style="position:absolute; bottom:1px; right:1px; border:3px solid" :to="{path: '/complaints/create'}">
              <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 v-else> <!-- community view for staffs -->
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/complaints'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">headset_mic</v-icon>Complaints
          </v-card-title>
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs6>
                <span class="subheading">Open</span>
                <div>
                  {{ totOpenComp }}
                </div>
                <v-chip v-if="totNewComp" class="white caption" small>{{totNewComp + ' new'}}</v-chip>
                <v-chip v-if="totCritComp" class="error white--text caption" small>{{totCritComp + ' critical'}}</v-chip>
              </v-flex>
              <v-flex xs6>
                <span class="subheading">Assigend to me</span>
                <br />
                {{ totMine }}
              </v-flex>
            </v-layout>
            <v-btn fab small class="primary lighten-2" style="position:absolute; bottom:1px; right:1px; border:3px solid" :to="{path: '/complaints/create'}">
              <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- visitors -->
      <v-flex xs6 sm3 v-if="!config.IS_OTHER_USER">
        <v-card :class="'display-1 text-xs-center white--text ' + (visitorList.detail && visitorList.detail.findIndex(det => det.visitor_status === 'Inside') >= 0 ? 'success lighten-1' : 'primary lighten-2')" :to="{path: '/myvisitors/today'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">transfer_within_a_station</v-icon>Visitors
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            <span v-if="!visitorList.stats || !visitorList.stats.length">0</span>
            <span v-else xs6 v-for="(rec, i) in visitorList.stats" :key="i">
              <v-icon small>{{visitCatIcon[rec.visitor_cat] || 'person'}}</v-icon>
              {{rec.tot_rec}}<sup class="error--text" v-if="rec.is_someone_waiting">*</sup>
            </span>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- notice board -->
      <v-flex xs6 sm3 v-if="!config.IS_OTHER_USER">
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/noticeboard'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">assignment</v-icon>Notices
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{ totNotice }}
            <v-chip v-if="totNotice" class="white caption" small>{{notices.length + ' new'}}</v-chip>
            <v-btn v-if="config.IS_USER_EMPOWERED" fab small class="primary lighten-2" style="position:absolute; bottom:1px; right:1px; border:3px solid" :to="{path: '/noticeboard/create'}">
              <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- posts -->
      <v-flex xs6 sm3 v-if="!config.IS_OTHER_USER">
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/posts'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">dynamic_feed</v-icon>Recent Posts
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{ posts.length }}
            <v-btn fab small class="primary lighten-2" style="position:absolute; bottom:1px; right:1px; border:3px solid" :to="{path: '/posts/create'}">
              <v-icon class="white--text">add</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Invoices -->
      <v-flex xs6 sm3 v-if="invoices && !config.IS_OTHER_USER">
        <v-card class="display-1 text-xs-center warning" :to="{path: '/invpay'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">money</v-icon>Invoice
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{handy.formatCur(invoices.tot_due)}}
            <v-chip v-if="invoices.past_due" class="error white--text caption" small>{{handy.formatCur(invoices.past_due) + ' past due'}}</v-chip>
            <v-chip v-if="invoices.due_today" class="warning white--text caption" small>{{handy.formatCur(invoices.due_today) + ' due today'}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Tasks -->
      <v-flex xs6 sm3 v-if="tasks && !config.IS_OTHER_USER">
        <v-card class="display-1 text-xs-center warning" :to="{path: '/task'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">group_work</v-icon>Task
          </v-card-title>
          <v-card-text class="px-2 pt-0 pb-1">
            {{tasks.tot_task}}
            <v-chip v-if="tasks.past_due" class="error white--text caption" small>{{tasks.past_due + ' past due'}}</v-chip>
            <v-chip v-if="tasks.due_today" class="warning white--text caption" small>{{tasks.due_today + ' due today'}}</v-chip>
            <v-chip v-if="tasks.pend_appr" class="white caption" small>{{tasks.pend_appr + ' for your approval'}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-else-if="tasks"> <!-- detailed view for staffs -->
        <v-card class="display-1 text-xs-center primary lighten-2 white--text" :to="{path: '/task'}">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">group_work</v-icon>Task
          </v-card-title>
          <v-card-text class="pa-0">
            {{tasks ? tasks.tot_task : 0}}
            <v-chip v-if="tasks && tasks.past_due" class="error white--text caption" small>{{tasks.past_due + ' past due'}}</v-chip>
            <v-chip v-if="tasks && tasks.due_today" class="warning white--text caption" small>{{tasks.due_today + ' due today'}}</v-chip>
            <v-chip v-if="tasks && tasks.pend_appr" class="white caption" small>{{tasks.pend_appr + ' for your approval'}}</v-chip>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- facility management for staffs -->
      <v-flex xs12 class="pt-2" v-if="config.IS_OTHER_USER">
        <v-card class="display-1 primary lighten-2">
          <v-card-title class="px-2 pt-1 pb-0 subheading black--text">
            <v-icon large class="pr-2">engineering</v-icon>Facility Management
            <v-spacer></v-spacer>
            <v-chip small disabled :class="'caption ml-0 mr-1 black--text ' + (statDay === 'yesterday' ? 'primary lighten-5' : 'primary lighten-3')" @click="loadStatsForStaffDashboard('yesterday')">yesterday</v-chip>
            <v-chip small disabled :class="'caption ma-0 black--text ' + (statDay === 'today' ? 'primary lighten-5' : 'primary lighten-3')" @click="loadStatsForStaffDashboard('today')">today</v-chip>
          </v-card-title>
          <v-card-text class="pa-3">
            <v-layout row wrap>
              <v-flex xs6 sm3>
                <v-card :to="{path: '/attendance'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:125px;">
                    <v-icon class="pr-2 warning--text">camera_front</v-icon>Attendance
                    <div class="text-xs-center display-1 white--text">
                      {{(attend.percent || 0) + '%'}}<br />
                      <v-chip v-if="attend.tot_pend" class="red white--text caption" small>{{attend.tot_pend + ' pending'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat>
                  <v-card-title class="pt-0 pb-0 pl-2 pr-0 subheading primary darken-1 warning--text">
                    <v-icon class="pr-2 warning--text">today</v-icon>Daily Update
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="showDateList = true"><v-icon color="white">open_in_new</v-icon></v-btn>
                  </v-card-title>
                </v-card>
                <v-card :to="{path: '/dailyupdate'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:85px;">
                    <div class="text-xs-center display-1 white--text">
                      {{dailyUpdate.c_date ? (dailyUpdate.is_sub_app || dailyUpdate.is_app ? 'Done' : 'Draft' ) : 'Pending'}} <br />
                      <v-chip v-if="dailyUpdate.tot_pend" class="red white--text caption" small>{{dailyUpdate.tot_pend + ' days pending'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat :to="{path: '/inventory'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:125px;">
                    <v-icon class="pr-2 warning--text">category</v-icon>Assets
                    <div class="text-xs-center display-1 white--text">
                      <span v-if="assets.amc_past_due">{{assets.amc_past_due}} <span class="body-1 red--text">AMC past due</span><br /></span>
                      {{assets.amc_due_soon}} <span :class="'body-1 ' + (assets.amc_due_soon ? 'red--text' : '')">AMC due soon</span>
                      <v-chip v-if="assets.tot_outside" class="white caption" small>{{assets.tot_outside + ' out for service'}}</v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3>
                <v-card flat :to="{path: '/incidents'}">
                  <v-card-text class="pt-1 pb-2 px-2 subheading primary darken-1 warning--text" style="height:125px;">
                    <v-icon class="pr-2 warning--text">report_problem</v-icon>Incidents
                    <div class="text-xs-center display-1 white--text">
                      {{incidents.length || 0}}
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- trending posts -->
      <v-flex xs12 class="pt-2" v-if="!config.IS_OTHER_USER || posts.length">
        <v-card>
          <v-card-title class="pa-2 subheading primary lighten-2 white--text">
            Trending
          </v-card-title>
          <v-card-text v-if="!posts.length" class="pa-2">
            Hm, no discussions yet. Break the silence, post something interesting!
            <v-btn :to="{path: '/posts'}" icon small flat class="accent">Go</v-btn>
          </v-card-text>
          <v-card-text v-else class="pa-1">
            <div v-for="(post, i) in posts" :key="i" v-if="post.post_status !== 'Recalled' && post.post_status !== 'Disabled' && post.post_status !== 'Rejected'">
              <!-- if post status is draft then it will be visible to only admin -->
              <v-card flat v-if="post.post_status !== 'Draft' || (post.post_status === 'Draft' && config.IS_ADMIN)" :to="{path: '/posts/' + (post.post_status === 'Draft' ? '2_' : '0_') + post.post_id}">
                <v-card-text class="pa-1">
                  <v-layout row>
                    <v-flex xs3 sm1>
                      <v-avatar size="48px" slot="activator" class="ml-2">
                        <img :src="config.FILE_URL(post.avatar_url)" alt="">
                      </v-avatar>
                    </v-flex>
                    <v-flex xs9 sm11 :class="$vuetify.breakpoint.sm?'ml-2':''">
                      <div class="subheading">{{ post.post_title }}
                        <span v-if="post.tagged_by == config.USER_ID" style="position:absolute; top:0px; right:5px"><v-icon color="yellow">star_border</v-icon></span>
                      </div>
                      <div v-if="post.post_status === 'Draft'" class="pa-1 red lighten-2 white--text caption" style="position:absolute; top:5px; right:0px">
                        Pending for approval
                      </div>
                      <div>
                        <span class="primary--text"> {{ post.cust_name + ' (' + (post.block_nm ? (post.block_nm + ',' + post.unit_no) : post.role_name) + ')' }} </span>
                        <span class="grey--text"> {{ ' - ' + handy.html2text(post.post_text).substring(0,35) + '...' }} </span>
                      </div>
                      <div class="caption grey--text mt-2">
                        <span class="mr-2" v-html="handy.formatDateTime(post.post_dt) + (post.edited_dt?'.':(handy.formatDateTime(post.post_dt).length > 10?'<br/>':''))"></span>
                        <span v-if="post.edited_dt" class="mr-2 black--text">Edited.<br /></span>
                      </div>
                      <div class="caption info--text">
                        <v-tooltip top :disabled="post.likes===0">
                          <template v-slot:activator="{ on }">
                            <span @mouseover="loadListOfPeopleLiked(post)" v-on="on" class="mr-2">{{ post.likes }} Likes</span>
                          </template>
                          <span v-for="(likes, i) in totalLikes" class="caption">{{ likes.cust_name + ' '+ '(' + (likes.block_nm ? (likes.block_nm + ',' + likes.unit_no) : likes.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                        <v-tooltip top :disabled="post.comments===0">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @mouseover="loadListOfPeopleCommented(post)" class="mr-2">{{ post.comments }} Comments</span>
                          </template>
                          <span v-for="(comment, i) in totalComment" class="caption">{{ comment.cust_name + ' ' + '(' + (comment.block_nm ? (comment.block_nm + ',' + comment.unit_no) : comment.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                        <v-tooltip top :disabled="post.tags===0">
                          <template v-slot:activator="{ on }">
                            <span v-on="on" @mouseover="loadListOfPeoplePinned(post)">{{ post.tags }} Pinned</span>
                          </template>
                          <span v-for="(pinned, i) in totalPinned" class="caption">{{ pinned.cust_name + ' '+ '(' + (pinned.block_nm ? (pinned.block_nm + ',' + pinned.unit_no) : pinned.role_name) +') ' }}<br/>
                          </span>
                        </v-tooltip>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
              </v-card>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>

    <v-dialog v-if="totDlgNotice" v-model="dlgNotice" max-width="500px" scrollable>
      <v-card flat>
        <v-card-title>
          <v-badge color="info" right>
            <span class="caption" v-if="notices[totDlgNotice-1].is_ad" slot="badge">Ad</span>
            <span class="title primary--text">Notice: {{ notices[totDlgNotice-1].notice_title }}</span>
          </v-badge>
        </v-card-title>
        <v-card-text class="pt-0">
          <div v-html="handy.getEditorStyle() + notices[totDlgNotice-1].notice_text">
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1">
          <v-spacer></v-spacer>
          <v-btn flat @click.native="ackNotice(false)">Remind Me Later</v-btn>
          <v-btn flat @click.native="ackNotice(true)" color="accent" :disabled="beingSaved">Got It</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgHowToResDir" max-width="500px">
      <v-card flat>
        <v-img
        :src="config.STATIC_FILES_DIR + '/img/others/resident_dir_setup.png'"
        :aspect-ratio="$vuetify.breakpoint.smAndUp ? '1.31' : '1.1'"
        ></v-img>
        <v-card-title class="title pb-1">
          Why to upload resident directory?
        </v-card-title>
        <v-card-text>
          <ul>
            <li>
              To set up list of houses in your community along with resident contact details
            </li>
            <li>
              It also sends out an invite to all your residents with detailed steps to join this community
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgHowToResDir=false">Close</v-btn>
          <v-btn flat color="accent" :to="{path:'/residents'}"><v-icon>file_upload</v-icon>Go to upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgHowToSecGaurd" max-width="500px">
      <v-card flat>
        <v-img
        :src="config.STATIC_FILES_DIR + '/img/others/guard_setup.png'"
        :aspect-ratio="$vuetify.breakpoint.smAndUp ? '1.55' : '1.2'"
        ></v-img>
        <v-card-title class="title pb-1">
          Security guard device
        </v-card-title>
        <v-card-text>
          An Android phone which needs to be setup and handed over to security guard at gate for managing the visitors.
          <ul class="mt-2">
            <li>
              A budget Android phone with 4G/WiFi connectivity
            </li>
            <li>
              Download the <a href="https://play.google.com/store/apps/details?id=in.smartility.app" target="_blank">Smartility Admin</a> app from Google playstore and install it
            </li>
            <li>
              While joining your community, let your guard choose the role as "Security"
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgHowToSecGaurd=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgCommSetup" max-width="500px">
      <v-card flat>
        <v-card-title class="title pb-1">
          Community setup completion
        </v-card-title>
        <v-card-text>
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="subheading primary--text"><strong>Core Module {{commSetupScore.setup_score.corScore}}%</strong></div>
              </template>
              <v-card flat>
                <v-card-text class="pa-2">
                  <ul>
                    <li>
                      Default settings <v-icon color="success">check</v-icon>
                    </li>
                    <li>
                      Minimum 10 residents onboarded
                      <v-icon v-if="commSetupScore.setup_score.totUnit >= 10" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Community > Resident Directory. Upload the list of residents</v-div>
                      </span>
                    </li>
                    <li>
                      Minimum 10 users using the app
                      <v-icon v-if="commSetupScore.setup_score.totUser >= 10" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Community > Noticeboard. Publish a notice to encourage the residents to use the app.</v-div>
                      </span>
                    </li>
                    <li>
                      Minimum 3 admin users
                      <v-icon v-if="commSetupScore.setup_score.totAdmin >= 3" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Admin's Corner > Users. Make appropriate users as admin.</v-div>
                      </span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="subheading primary--text"><strong>Visitor Module {{commSetupScore.setup_score.vmScore}}%</strong></div>
              </template>
              <v-card flat>
                <v-card-text class="pa-2">
                  <ul>
                    <li>
                      Default settings <v-icon color="success">check</v-icon>
                    </li>
                    <li>
                      Security guard post
                      <v-icon v-if="commSetupScore.setup_score.totSecPost >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                      </span>
                    </li>
                    <li>
                      Minimum 1 security guard onboarded
                      <v-icon v-if="commSetupScore.setup_score.totSecUser >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Download and install Smartility Admin app. Guide security guard to join your community.</v-div>
                      </span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="subheading primary--text"><strong>Accounting Module {{commSetupScore.setup_score.acScore}}%</strong></div>
              </template>
              <v-card flat>
                <v-card-text class="pa-2">
                  <ul>
                    <li>
                      Default settings <v-icon color="success">check</v-icon>
                    </li>
                    <li>
                      Minimum 10 residents onboarded
                      <v-icon v-if="commSetupScore.setup_score.totUnitAc >= 10" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Community > Resident Directory. Upload the list of residents</v-div>
                      </span>
                    </li>
                    <li>
                      Minimum 1 bank account configured
                      <v-icon v-if="commSetupScore.setup_score.totBank >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Accounts > Bank & Cash. Create a new bank account</v-div>
                      </span>
                    </li>
                    <li>
                      Account opening balance configured
                      <v-icon v-if="commSetupScore.setup_score.totOPBal >= 1 || commSetupScore.setup_score.totChargeConfig >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Accounts > Account Heads. Configure opening balance</v-div>
                      </span>
                    </li>
                    <li>
                      Maintenance charge configured
                      <v-icon v-if="commSetupScore.setup_score.totChargeConfig >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Go to Accounts > Charge Config. Setup a maintenance charge to be billed</v-div>
                      </span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="subheading primary--text"><strong>Facility Module {{commSetupScore.setup_score.fmScore}}%</strong></div>
              </template>
              <v-card flat>
                <v-card-text class="pa-2">
                  <ul>
                    <li>
                      Default settings <v-icon color="success">check</v-icon>
                    </li>
                    <li>
                      Minimum 1 facility staff onboarded
                      <v-icon v-if="commSetupScore.setup_score.totStaff >= 1" color="success">check</v-icon>
                      <span v-else>
                        <v-icon color="warning">pending_actions</v-icon></br>
                        <v-div class="caption grey--text">Guide your facility staffs (Facility Manager/Helpdesk Executive) to join your community as staff.</v-div>
                      </span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgCommSetup=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgHowToiPhone" max-width="500px">
      <v-card flat>
        <v-card-title class="title pb-1">
          How to install in iPhone?
        </v-card-title>
        <v-card-text>
          <ul class="mt-2">
            <li>
              Open your safari browser
            </li>
            <li>
              Go to <a href="https://myapp.smartility.com.my" target="_blank">https://myapp.smartility.com.my</a>
            </li>
            <li>
              Tap on share icon at the bottom of your browser window
            </li>
            <li>
              Tap on "Add to Home Screen" to install the app
            </li>
          </ul>
          <div class="text-xs-center">
            <img width="85%" :src="config.STATIC_FILES_DIR + '/img/others/pwa_install.png'"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dlgHowToiPhone=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar"
    :timeout="2000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

</v-container>
</div>

<v-dialog v-model="showDateList" scrollable max-width="500px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      List Of FM Daily Update Pending dates
      <v-spacer></v-spacer>
      <v-btn icon @click="showDateList = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
      :headers="dateHeader"
      :items="dailyUpdate.dateList"
      class="elevation-1"
      hide-actions>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ handy.formatDate(props.item.selected_date) }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-dialog>

<!-- display water mark if there is too much space in dashboard, usually will happen for a fresh user/community -->
<div v-if="!posts.length">
  <v-container>
    <v-layout>
      <v-flex xs12 class="text-xs-center mt-4" style="opacity: 0.25;">
        <img height="64" :src="config.STATIC_FILES_DIR + '/img/logo/smartility_admin.png'">
      </img>
    </v-flex>
  </v-layout>
</v-container>
</div>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { logout } from '@/utils/auth'

export default {
  data () {
    return {
      // common
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      handy: handy,
      config: config,
      beingSaved: false,
      // notice board
      notices: [],
      totNotice: 0,
      dlgNotice: false,
      // post
      posts: [],
      show: false,
      // admins
      joinReq: [],
      // invoice
      invoices: '',
      tasks: '',
      // complaints
      totMine: 0,
      totOpenComp: 0,
      totNewComp: 0,
      totCritComp: 0,
      totPersComp: 0,
      // visitors
      visitorList: [],
      visitCatIcon: {
        'Guest': 'face',
        'Daily Helper': 'people',
        'Delivery': 'shopping_cart',
        'Cab': 'directions_car',
        'Vendor': 'build'
      },
      // fm
      statDay: 'today',
      attend: '',
      dailyUpdate: '',
      assets: '',
      incidents: '',
      totalLikes: [],
      totalPinned: [],
      totalComment: [],
      showDateList: false,
      dateHeader: [
        { text: 'Dates', values: 'selected_date' }
      ],
      dlgHowToResDir: false,
      dlgHowToSecGaurd: false,
      dlgHowToiPhone: false,
      commSetupScore: {subscription: {}, setup_score: {}},
      isCommSetupPend: false,
      isMobAdminUser: true,
      dlgCommSetup: false
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    },
    nextThreeDays: function () {
      let curDt = new Date()
      curDt.setDate(curDt.getDate() + 3)
      return handy.formatDBDate(curDt)
    },
    totDlgNotice: function () {
      if (this.notices.length) {
        this.dlgNotice = true
      } else {
        this.dlgNotice = false
      }
      return this.notices.length
    }
  },
  created () {
    this.refreshDashboard()
  },
  watch: {
    '$route' (to, from) {
      this.refreshDashboard()
      this.$forceUpdate()
    }
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    refreshDashboard () {
      // note: all these methods are asyncronous and will be loaded independantly
      if (config.IS_ADMIN) {
        this.loadCommSetupScore()
      } else {
        this.isCommSetupPend = false
      }
      this.loadIsMobAdminUser()
      if (config.UNIT_ID_LIST.length || config.IS_ADMIN) {
        this.loadJoinReq()
      }
      if (!config.IS_OTHER_USER) {
        this.loadInvoices()
      }
      this.loadComps()
      this.loadVisitors()
      this.loadNotices()
      this.loadPosts()
      this.loadTasks()
      if (config.IS_OTHER_USER) {
        this.loadStatsForStaffDashboard()
      }
    },
    cancelReq (curUnit) {
      if (confirm('Sure, you want to cancel the request?')) {
        var req = {
          unit_id: curUnit.unit_id,
          cust_id: config.CUST_ID,
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          is_other_user: config.IS_OTHER_USER
        }
        this.axios.post(config.API_URL + '/admin/cancel-req', req)
        .then(response => {
          // refresh list in front end
          logout()
        })
        .catch(err => {
          this.msg(err.response.data, true)
        })
      }
    },
    logout () {
      logout()
    },
    loadTasks () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getOpenTaskSummaryByUserId/', qry)
      .then(response => {
        this.tasks = response.data[0]
      })
    },
    loadInvoices () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          cust_id: config.CUST_ID,
          unit_id_list: config.UNIT_ID_LIST,
          include_detail: true
        }
      }
      this.invoices = ''
      this.axios.get(config.API_URL + '/getAccBalByCustId/', qry)
      .then(response => {
        if (response.data.length) {
          this.invoices = {}
          this.invoices.tot_due = Number(response.data.map(rec => rec.pending_amount).reduce((a, b) => Number(a || 0) + Number(b || 0), 0))
          this.invoices.past_due = Number(response.data.filter(rec => !rec.due_dt || handy.formatDBDate(rec.due_dt) < this.today).map(rec => rec.pending_amount).reduce((a, b) => Number(a || 0) + Number(b || 0), 0))
          this.invoices.due_today = Number(response.data.filter(rec => handy.formatDBDate(rec.due_dt) === this.today).map(rec => rec.pending_amount).reduce((a, b) => Number(a || 0) + Number(b || 0), 0))
        }
      })
    },
    loadNotices () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getNoticesByCommId/', qry)
      .then(response => {
        this.totNotice = response.data.length
        this.notices = response.data.filter(rec => !rec.is_ack)
      })
    },
    ackNotice (isAck) {
      // update db if acknowledged
      if (isAck) {
        this.beingSaved = true
        this.axios.post(config.API_URL + '/notice/ack', {'notice_id': this.notices[this.totDlgNotice - 1].notice_id, 'user_id': config.USER_ID, 'comm_id': config.COMM_ID})
        .then(response => {
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, true)
          this.beingSaved = false
        })
      }
      // pop out
      this.notices.splice(this.totDlgNotice - 1, 1)
    },
    loadPosts () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getTrendingPost/', qry)
      .then(response => {
        this.posts = response.data
      })
    },
    loadComps () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // users complaints (created by / assigned to this user)
      this.totMine = 0
      this.axios.get(config.API_URL + '/getComplaintsByUser/', qry)
      .then(response => {
        this.totMine = response.data.length
      })
      // all open complaints
      this.totOpenComp = 0
      this.totNewComp = 0
      this.totCritComp = 0
      this.axios.get(config.API_URL + '/getComplaintsByComm/', qry)
      .then(response => {
        this.totOpenComp = response.data.length
        this.totNewComp = response.data.filter(rec => rec.comp_status === 'New').length
        this.totCritComp = response.data.filter(rec => rec.comp_severity === 'Critical').length
      })
    },
    loadCommSetupScore () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommSetupCompScore/', qry)
      .then(response => {
        this.commSetupScore = response.data
        this.isCommSetupPend = this.commSetupScore.setup_score.corScore <= this.commSetupScore.setup_score.corScoreBase && this.commSetupScore.subscription.collab_module  // only FM clients
        this.isCommSetupPend = this.isCommSetupPend || this.commSetupScore.subscription.visitor_module && this.commSetupScore.setup_score.vmScore <= this.commSetupScore.setup_score.vmScoreBase
        this.isCommSetupPend = this.isCommSetupPend || this.commSetupScore.subscription.accounts_module && this.commSetupScore.setup_score.acScore <= this.commSetupScore.setup_score.acScoreBase
        this.isCommSetupPend = this.isCommSetupPend || this.commSetupScore.subscription.facility_module && this.commSetupScore.setup_score.fmScore <= this.commSetupScore.setup_score.fmScoreBase
        this.$forceUpdate()
      })

      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadIsMobAdminUser () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID
        }
      }
      // load joining request of new user for the particular community
      this.axios.get(config.API_URL + '/getIsMobileAdminUser/', qry)
      .then(response => {
        this.isMobAdminUser = response.data.length
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadJoinReq () {
      var qry = {
        params: {
          unit_id_list: config.UNIT_ID_LIST,
          comm_id: config.COMM_ID,
          is_admin: config.IS_ADMIN,
          user_id: config.USER_ID
        }
      }
      // load joining request of new user for the particular community
      this.axios.get(config.API_URL + '/getJoiningRequest/', qry)
      .then(response => {
        this.joinReq = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.joinReq = []
      })
    },
    loadVisitors () {
      // load today's visitors
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          unit_id_list: config.IS_OTHER_USER ? '' : config.PRIVATE_UNIT_ID_LIST,
          user_id: config.USER_ID,
          from_dt: this.today,
          to_dt: this.today
        }
      }
      this.axios.get(config.API_URL + '/getMyVisitorByPeriodAndStatus/', qry)
      .then(response => {
        this.visitorList = response.data
      })
    },
    loadStatsForStaffDashboard (statDay = this.statDay) {
      this.statDay = statDay
      let statDate = this.today
      if (statDay === 'yesterday') {
        var curDate = new Date()
        statDate = handy.formatDBDate(curDate.setDate(curDate.getDate() - 1))
      }
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          user_id: config.USER_ID,
          stat_dt: statDate
        }
      }
      // all open complaints
      this.axios.get(config.API_URL + '/getComplaintsByComm/', qry)
      .then(response => {
        this.totOpenComp = response.data.length
        this.totNewComp = response.data.filter(rec => rec.comp_status === 'New').length
        this.totCritComp = response.data.filter(rec => rec.comp_severity === 'Critical').length
      })
      // attendace
      this.axios.get(config.API_URL + '/getAttendanceStat/', qry)
      .then(response => {
        this.attend = response.data
      })
      // daily update
      this.axios.get(config.API_URL + '/getDailyUpdateStat/', qry)
      .then(response => {
        this.dailyUpdate = response.data
      })
      // asset
      this.axios.get(config.API_URL + '/getAssetsForAMCDue/', qry)
      .then(response => {
        this.assets = response.data
      })
      // incidents
      qry.params.incident_status = 'Open'
      qry.params.as_on = qry.params.stat_dt
      this.axios.get(config.API_URL + '/getIncidentsByCommId/', qry)
      .then(response => {
        this.incidents = response.data
      })
    },
    loadListOfPeopleLiked (curPost) {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          post_id: curPost.post_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeopleLiked/', qry)
      .then(response => {
        this.totalLikes = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadListOfPeopleCommented (curPost) {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          post_id: curPost.post_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeopleCommented/', qry)
      .then(response => {
        this.totalComment = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadListOfPeoplePinned (curPost) {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          post_id: curPost.post_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfPeoplePinned/', qry)
      .then(response => {
        this.totalPinned = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?24fa4b7e